// Config adapter: the single registry of feature-flag keys, so callers reference FLAGS.*
// instead of magic strings.
export const FLAGS = {
  // Per-surface render gate (App).
  assistantDtEnabled: 'magic-apron-assistant-dt-enabled',
  assistantMwEnabled: 'magic-apron-assistant-mw-enabled',
  assistantAppEnabled: 'magic-apron-assistant-app-enabled',
  assistantB2bEnabled: 'magic-apron-assistant-b2b-enabled',

  // JOURNEY SWITCH (App): opts INTO the consolidated journey; absence resolves `legacy`.
  assistantUnifiedEnabled: 'isLiveChatUnificationEnabled',

  assistantUnifiedAppEnabled: 'isLiveChatUnificationAppEnabled',

  // Config-driven page exclusion (App; MAG4-815). Only the consolidated journey uses the wider
  // page set it allows; `legacy`, and every journey while it is off, stays on the legacy
  // allow-list (`getIsLegacyCompatiblePage`). See .claude/context/page-classification.md.
  exclusionRulesEnabled: 'magic-apron-assistant-enable-exclusion-rules',
  excludedPages: 'magic-apron-assistant-excluded-pages',

  // OPS KILL SWITCH for the liveAgent block, read in useResolvedJourney — see
  // .claude/context/journey-resolution.md.
  liveAgentEnabled: 'magic-apron-assistant-live-agent-enabled',

  // A/B/C test of the overlay placement (useDrawerController): one of OVERLAY_TEST_ARMS below.
  // Unset or unknown is `control`. See src/shell/overlay/README.md.
  overlayTestArm: 'magic-apron-overlay-test-arm',

  // Rollout and kill switches for initial page questions (pageView), per surface. At most one
  // maaSuggestedQuestions call per page view, not per session: size rollout to its global limiter.
  contextualLandingDtEnabled: 'magic-apron-contextual-landing-dt-enabled',
  contextualLandingMwEnabled: 'magic-apron-contextual-landing-mw-enabled',
  contextualLandingAppEnabled: 'magic-apron-contextual-landing-app-enabled',

  // Dynamic initial suggested questions (useMessageHistory).
  dynamicIsqMasterEnabled: 'magic-apron-initial-suggested-questions-enabled',
  dynamicIsqDtEnabled: 'magic-apron-dynamic-isq-dt-enabled',
  dynamicIsqMwEnabled: 'magic-apron-dynamic-isq-mw-enabled',
  dynamicIsqAppEnabled: 'magic-apron-dynamic-isq-app-enabled',
  dynamicIsqB2bEnabled: 'magic-apron-dynamic-isq-b2b-enabled',

  // RELEASE TOGGLE (App): the header's bottom-nav entry point and FAB suppression behind it.
  // header-footer-static and magic-apron read the same key.
  assistantMobileNavEntryEnabled: 'magic-apron-assistant-mobile-nav-entry-enabled',
};

// The values FLAGS.overlayTestArm can take.
export const OVERLAY_TEST_ARMS = {
  control: 'control',
  adaptive: 'adaptive',
  overlayOnly: 'overlay-only',
};
